"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFormLabelStyles = void 0;

var makeFormLabelStyles = function makeFormLabelStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: tokens.colors["ink-on-background"].rgb
          },
          "&.Mui-disabled": {
            color: tokens.colors["ink-on-background"].rgb
          }
        },
        asterisk: {
          display: "none"
        }
      }
    }
  };
};

exports.makeFormLabelStyles = makeFormLabelStyles;